import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Menu, MenuOpenRounded } from '@mui/icons-material';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { Badge, Box, IconButton } from '@mui/material';
import { createSubsetSelector } from 'webui/utils/selectors';
import { preventDefault } from 'shared/hooks/utils';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { unread_count_selector } from './selectors';
import { DeviceHeader } from './device';
import { selectMapDashboardActive } from 'pages/dashboard.map/model/selectors';
import { MapHeader } from './map';
import { selectZthDashboardActive } from 'console/dashboards/zth/actions';
import { DashboardHeader } from './dashboard';
import { is_dashboard_selected } from 'console/dashboards/z3k/selectors';
import { billedSimsWithProblems } from 'console/sim/utils/sim-problem';
import { selectSelectedDevice } from 'entities/device/lib';
const deviceSelector = createSelector(selectSelectedDevice, createSubsetSelector([
    'id',
    'iconState',
    'name',
    'device_type',
    'individual_device_name',
    'capabilities',
    'power_source',
    'gps_state',
    'voltage',
    'online',
    'last_gps',
]));
export const SmallHeader = memo(function SmallHeader(props) {
    const { onClick, menu_opened } = props;
    const device = useAppSelector(deviceSelector);
    const unread_count = useAppSelector(unread_count_selector);
    const billed_problem_sims_count = useAppSelector((state) => billedSimsWithProblems(state).length);
    const click_events = useMemo(() => ({
        onClick,
        onTouchStart: onClick,
        onTouchEnd: preventDefault,
    }), [onClick]);
    const is_medium_ui = isMediumUI();
    const map_selected = useAppSelector(selectMapDashboardActive);
    const zth_dashboard_active = useAppSelector(selectZthDashboardActive);
    const dashboard_selected = useAppSelector(is_dashboard_selected);
    const small_ui_menu = useMemo(() => (_jsx(Badge, { badgeContent: unread_count + billed_problem_sims_count, color: "error", children: _jsx(Menu, {}) })), [is_medium_ui, unread_count, billed_problem_sims_count]);
    const medium_ui_menu = useMemo(() => (menu_opened ? _jsx(MenuOpenRounded, {}) : small_ui_menu), [menu_opened, small_ui_menu]);
    const header = useMemo(() => {
        if (map_selected) {
            return _jsx(MapHeader, {});
        }
        if (dashboard_selected) {
            return _jsx(DashboardHeader, { has_settings: true });
        }
        if (device) {
            return _jsx(DeviceHeader, { device: device });
        }
        return null;
    }, [map_selected, device, zth_dashboard_active, dashboard_selected]);
    return (_jsxs(Box, { className: "MobileUIHeader", display: "flex", alignItems: "center", columnGap: 1, px: "10px", bgcolor: "background.default", fontSize: "2rem", children: [_jsx(IconButton, { size: "large", edge: "start", "aria-label": "menu", "data-tooltip": "left-menu-button", ...click_events, children: is_medium_ui ? medium_ui_menu : small_ui_menu }), header] }));
});
